export default {
  title: 'Other'
}
